import { LocalStorageService } from '@/services/localStorageService';
import { CONSTANTS, LOCAL_STORAGE_KEYS } from '@/constants';

export const getCCPAAccess = () =>
	(LocalStorageService?.get(LOCAL_STORAGE_KEYS.COUNTRY_CODE, '') as string) ===
	CONSTANTS.COOKIES_ACCESS_CCPA_COUNTRY;
